/**
 * Forms & documents page.
 */
(function () {
  'use strict';

  async function init() {
    const container = document.getElementById('documents-list');
    if (!container) return;

    const docs = await window.Troop936Content.loadDocuments();
    container.classList.remove('is-loading');

    if (!docs.length) {
      container.innerHTML = `
        <div class="card">
          <p><strong>Annual Health and Medical Record (AHMR)</strong></p>
          <p class="muted">Required for all scouts and adults for camping and summer camp.</p>
          <p><a href="https://www.scouting.org/health-and-safety/ahmr/" target="_blank" rel="noopener">Download from Scouting.org →</a></p>
        </div>
      `;
      return;
    }

    const byCategory = {};
    docs.forEach((d) => {
      if (!byCategory[d.category]) byCategory[d.category] = [];
      byCategory[d.category].push(d);
    });

    container.innerHTML = Object.entries(byCategory)
      .map(([cat, items]) => `
        <h2>${escapeHtml(cat)}</h2>
        <div class="doc-grid">
          ${items.map((d) => `
            <article class="card doc-card">
              <h3>${escapeHtml(d.title)}</h3>
              ${d.description ? `<p class="muted">${escapeHtml(d.description)}</p>` : ''}
              ${d.file_url
                ? `<a class="btn btn-primary btn-sm" href="${escapeAttr(d.file_url)}" target="_blank" rel="noopener">Open / Download</a>`
                : '<p class="muted">Contact the scoutmaster for a copy.</p>'}
            </article>
          `).join('')}
        </div>
      `).join('');
  }

  function escapeHtml(str) {
    const d = document.createElement('div');
    d.textContent = str || '';
    return d.innerHTML;
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/"/g, '&quot;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

export {};
